<button mat-icon-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger" class="lang-btn" aria-label="שינוי שפה">
  <img [src]="'assets/images/flags/'+translateService.currentLang+'.svg'" width="22" [alt]="translateService.currentLang" class="mat-elevation-z1">
</button>
<mat-menu #langMenu="matMenu" [overlapTrigger]="false" class="app-menu-panel lang">
  <span (mouseleave)="langMenuTrigger.closeMenu()">
    @for (lang of translateService.getLangs(); track lang) {
      <button mat-menu-item (click)="changeLang(lang)">
        <img [src]="'assets/images/flags/'+lang+'.svg'" width="22" [alt]="lang" class="mat-elevation-z1">
      </button>
    }
  </span>
</mat-menu>